import React, { useRef, useEffect, useState } from "react";
import Header from "../header/Header";
import IMAGE from "../../assets/images/table.jpeg";
import IMAGE1 from "../../assets/images/builder 2.png";
import FACEBOOK from "../../assets/images/uil_facebook.png";
import INSTA from "../../assets/images/ri_instagram-fill.png";
import LINKEDIN from "../../assets/images/mdi_linkedin.png";
import Accordion from "../../commonComponents/accordion/Accordion";
import Footer from "../footer/Footer";
import VerticalCarousel from "../../commonComponents/VerticalCarousel";
import Carousel from "../../commonComponents/Carousel";
import BHK1 from "../../assets/images/1bhk2.webp";
import BHK2 from "../../assets/images/2bhk.jpg";
import BHK3 from "../../assets/images/3bhk.jpg";
import BHK4 from "../../assets/images/4bhk.jpg";
import TICK from "../../assets/images/tick.jpg";
import VILLA1 from "../../assets/images/villa1.png";
import VILLA2 from "../../assets/images/villa2.png";
import VILLA3 from "../../assets/images/villa3.png";
import VILLA4 from "../../assets/images/villa4.png";
import RERA from "../../assets/images/rera2.png";
import DTCP from "../../assets/images/dtcp.jpg";
import MasonryGrid from "../../commonComponents/MasonaryLayout";
import ContactUs from "./ContactUs";

function HomeScreen() {
  const overviewRef = useRef(null);
  const amenitiesRef = useRef(null);
  const configRef = useRef(null);
  const floorPlanRef = useRef(null);
  const contactform = useRef(null);
  const [loaded, setLoaded] = useState(false);

  // useEffect(() => {
  //     setLoaded(true);
  // }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoaded(true);
    }, 1000); // Delay to show skeleton for at least 1 second
    return () => clearTimeout(timer); // Cleanup on unmount
  }, []);
  const scrollToSection = (ref) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  return (
    <div style={{ fontFamily: "auto" }}>
      <Header
        scrollToSection={scrollToSection}
        overviewRef={overviewRef}
        amenitiesRef={amenitiesRef}
        configRef={configRef}
        floorPlanRef={floorPlanRef}
        contactform={contactform}
      />
      <div className="max-w-1440 w-full mx-auto xl:px-[5vh] lg:px-[2vh]  px-[1vh]  pt-2">
        <div className="relative w-full lg:h-[730px] md:h-[388px] h-[290px] rounded-xl overflow-hidden">
          {loaded ? (
            <video
              className="absolute top-0 left-0 w-full h-full object-cover"
              autoPlay
              loop
              muted
              playsInline
              preload="auto"
            >
              <source src="/Mr-housing.mp4" type="video/mp4" />
              <source src="/video.webm" type="video/webm" />
              Your browser does not support the video tag.
            </video>
          ) : (
            <div className="w-full h-full bg-gray-300 animate-pulse"></div>
          )}
          <div className="absolute top-0 left-0 bg-white rounded-br-[30px] shadow-md xl:px-[10px] lg:px-[24px] px-[10px]  flex items-center">
            <div>
              <span className="lg:text-[40px] md:text-[13px] text-[8px] font-bold text-[#236592]">
                Mr.housing india
              </span>
              <p className="text-[16px] text-center font-medium">
                A Life of Wellness & Luxury Awaits!
              </p>
            </div>
          </div>
        </div>
        <div
          className="lg:grid lg:grid-cols-12 gap-[5px]  lg:px-[4px] px-[20px] lg:mt-[100px] mt-[50px]"
          ref={overviewRef}
        >
          <div className="col-span-6 xl:leading-[10px] leading-[15px]">
            <h1 className="lg:text-[30px] md:text-[24px] text-[22px] font-bold poppins">
              A Home That Nurtures Your Family’s Health & Happiness
            </h1>
            <p className="my-3">
              🏡 Exclusive Bali-themed villas in a wellness-driven community
            </p>
            <p className="mb-3">
              🌱 Live amidst nature, fresh air & eco-friendly landscapes
            </p>
            <p className="mb-3">
              🧘 Wellness-focused amenities – yoga decks, meditation zones & spa
            </p>
            <p className="mb-3">
              👨‍👩‍👧‍👦 Perfect for families with kids, elders & multiple generations
            </p>
            <p className="mb-3">
              🏊 Resort-style clubhouse, infinity pool & kids’ play areas
            </p>
            <p className="mb-3">
              📍 Strategically located for peace, yet well-connected to the city
            </p>
          </div>
          <div className="col-span-6 lg:mt-0 mt-[20px]">
            <div className="grid grid-cols-12 ">
              <div className="md:col-span-4 col-span-6 border-r-[1px] border-black">
                <h1 className="font-bold lg:text-[30px] md:text-[24px] text-[22px] text-center poppins">
                  33
                </h1>
                <p className="lg:text-[18px] text-[16px] font-normal text-center">
                  Acres
                </p>
              </div>

              <div className="md:col-span-4 col-span-6 md:border-r-[1px] md:border-black">
                <h1 className="font-bold lg:text-[30px] md:text-[24px] text-[22px] text-center poppins">
                  100+{" "}
                </h1>
                <p className="lg:text-[18px] text-[16px] font-normal text-center">
                  {" "}
                  villas
                </p>
              </div>
              <div className="md:col-span-4 col-span-6  md:mt-0 mt-[20px] border-r-[1px] border-black">
                <h1 className="font-bold lg:text-[30px] md:text-[24px] text-[22px] text-center poppins">
                  130
                </h1>
                <p className="lg:text-[18px] text-[16px] font-normal text-center">
                  villa plots
                </p>
              </div>
              <div className="md:col-span-4 col-span-6   mt-[20px] md:border-r-[1px] md:border-black">
                <h1 className="font-bold lg:text-[30px] md:text-[24px] text-[22px] text-center poppins">
                  2026{" "}
                </h1>
                <p className="lg:text-[18px] text-[16px] font-normal text-center">
                  Possession
                </p>
              </div>
              <div className="md:col-span-8 col-span-12   mt-[20px] md:border-r-[1px] md:border-black">
                <h1 className="font-bold lg:text-[30px] md:text-[24px] text-[22px] text-center poppins">
                  APPROVED BY
                </h1>
                <div>
                  <div className="flex justify-center items-center">
                    <img src={RERA} alt="rera" className="w-[22px] h-[22px]" />
                    <div className="lg:text-[18px] text-[16px] font-normal ml-2 mr-8">
                      RERA
                    </div>
                    <img src={TICK} alt="tick" className="w-[25px] h-[25px]" />
                  </div>
                  <div className="flex justify-center items-center">
                    <img src={DTCP} alt="dtcp" className="w-[25px] h-[25px]" />
                    <div className="lg:text-[18px] text-[16px] font-normal ml-2 mr-8">
                      DTCP
                    </div>
                    <img src={TICK} alt="tick" className="w-[25px] h-[25px]" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="lg:grid lg:grid-cols-12 lg:py-[100px] py-[50px] gap-4">
          <div className="col-span-5 ">
            <h1 className="text-[#3D52A1] font-bold lg:text-[48px] md:text-[36px] text-[28px]  poppins flex lg:justify-start justify-center">
              MR.HOUSING INDIA OVERVIEW
            </h1>
            <p className="lg:text-[18px] text-[16px] font-normal lg:justify-start justify-center lg:text-justify">
              Welcome to Mr.Housing India Villas – A Life of Wellness & Luxury
              Awaits! Exclusive Bali-Themed, Fully Furnished Wellness Resort
              Villas in Hyderabad 🌿 Experience a life of tranquility, wellness,
              and high-end luxury. Nestled in the lush landscapes of
              Shankarpally, Mr.Housing India Villas offers a 5-star resort-style
              gated community designed for elite individuals who seek peace,
              exclusivity, and a world-class lifestyle.
            </p>
          </div>
          <div className="col-span-7 lg:mt-0 mt-[20px]">
            <VerticalCarousel />
          </div>
        </div>
        <div className="text-center px-[20px] lg:mb-[100px] mb-[50px]">
          <h1 className="lg:text-[48px] md:text-[36px] text-[28px] text-[#3D52A1] font-bold poppins ">
            PROJECT AMENITIES
          </h1>
          <p className="lg:text-[18px] text-[16px] font-normal">
            Welcome to this 33-hectare township, surrounded by residential,
            commercial, and retail hubs. Choose from 1,2,3 or 4 BHK apartments
            that blend elegance and comfort, nestled amidst lush greenery and
            rolling hills. With 50+ lifestyle amenities, including a golf
            course, clubhouse, pet parks, and rooftop lounges, you’ll enjoy a
            life full of excitement and tranquility.{" "}
          </p>
          <div
            className="lg:pt-[50px] md:pt-[30px] pt-[15px] text-center"
            ref={amenitiesRef}
          >
            <Carousel />
          </div>
        </div>
        <div className="text-center">
          <h1 className="lg:text-[48px] md:text-[36px] text-[28px] font-bold text-[#3D52A1] poppins pb-[15px]">
            PROJECT CONFIGURATION
          </h1>
          <p className="lg:text-[18px] text-[16px] font-normal" ref={configRef}>
            {" "}
            Designed with eco-friendly landscapes, pedestrian pathways, and a
            central park, ensuring a serene and pollution-free environment.
          </p>
          <div className="lg:mt-[100px] mt-[50px] md:grid md:grid-cols-12 lg:pr-[225px] md:pr-[50px]">
            <div className="md:col-span-6 text-start md:px-[50px] py-[20px] relative">
              <div className=" clip-triangle bg-[#236592] w-[30px] h-[30px] absolute md:left-9 top-0"></div>
              <h3 className="text-[#7191E6] md:text-[24px] text-[16px] font-bold border-b-[1px] border-[#7191E6] md:mt-0 mt-3">
                1 BHK Villa
              </h3>
              <h1 className="lg:text-[30px] md:text-[24px] text-[22px] font-bold poppins">
                600 Sq. Ft
              </h1>
              <div className="grid grid-cols-12 gap-6 mt-3">
                <div className="col-span-4">
                  <img src={VILLA1} alt="villa" className="h-[50px] w-[50px]" />
                  <p className="font-normal text-[16px]">Bali-Themed Villas</p>
                </div>
                <div className="col-span-4">
                  <img src={VILLA2} alt="villa" className="h-[50px] w-[50px]" />
                  <p className="font-normal text-[16px]">Fully Furnished</p>
                </div>
              </div>
              <div className="grid grid-cols-12 gap-6 mt-3">
                <div className="col-span-4">
                  <img src={VILLA3} alt="villa" className="h-[50px] w-[50px]" />
                  <p className="font-normal text-[16px]">
                    Private Swimming Pool
                  </p>
                </div>
                <div className="col-span-4">
                  <img src={VILLA4} alt="villa" className="h-[50px] w-[50px]" />
                  <p className="font-normal text-[16px]">
                    Maintained By 5-Star Resort
                  </p>
                </div>
              </div>
              <button
                className="md:mt-2 text-[18px] text-white bg-[#7191E6] rounded-[6px] px-[20px] py-[12px] font-bold"
                onClick={() => scrollToSection(contactform)}
              >
                Get in Touch
              </button>
            </div>
            <div className="md:col-span-6">
              <div className="relative lg:w-[450px] md:w-[300px] w-full lg:h-[500px] md:h-[350px] h-[200px] p-4">
                <div className="absolute top-0 left-0 lg:w-[400px] md:w-[250px] w-[160px] lg:h-[400px] md:h-[250px] h-[160px] bg-[#236592] clip-triangle"></div>
                <div className="relative  rounded-lg">
                  <img
                    src={BHK1}
                    alt="Styled Interior"
                    className="lg:w-[450px]  md:w-[300px] w-full lg:h-[460px] md:h-[350px] h-[200px]"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="lg:mt-[100px] mt-[50px] md:grid md:grid-cols-12 lg:pl-[225px] md:pl-[80px]">
            <div className="relative col-span-6 text-start md:px-[50px] py-[20px]">
              <div className=" clip-triangle bg-[#236592] w-[30px] h-[30px] absolute md:left-9 top-0 "></div>
              <h3 className="text-[#7191E6] md:text-[24px] text-[16px] font-bold border-b-[1px] border-[#7191E6] md:mt-0 mt-3">
                2 BHK Villa
              </h3>
              <h1 className="lg:text-[30px] md:text-[24px] text-[22px] font-bold poppins">
                900 Sq. Ft
              </h1>
              <div className="grid grid-cols-12 gap-6 mt-3">
                <div className="col-span-4">
                  <img src={VILLA1} alt="villa" className="h-[50px] w-[50px]" />
                  <p className="font-normal text-[16px]">Bali-Themed Villas</p>
                </div>
                <div className="col-span-4">
                  <img src={VILLA2} alt="villa" className="h-[50px] w-[50px]" />
                  <p className="font-normal text-[16px]">Fully Furnished</p>
                </div>
              </div>
              <div className="grid grid-cols-12 gap-6 mt-3">
                <div className="col-span-4">
                  <img src={VILLA3} alt="villa" className="h-[50px] w-[50px]" />
                  <p className="font-normal text-[16px]">
                    Private Swimming Pool
                  </p>
                </div>
                <div className="col-span-4">
                  <img src={VILLA4} alt="villa" className="h-[50px] w-[50px]" />
                  <p className="font-normal text-[16px]">
                    Maintained By 5-Star Resort
                  </p>
                </div>
              </div>
              <button
                className="md:mt-2 text-[18px] text-white bg-[#7191E6] rounded-[6px] px-[20px] py-[12px] font-bold"
                onClick={() => scrollToSection(contactform)}
              >
                Get in Touch
              </button>
            </div>
            <div className="col-span-6">
              <div className="relative lg:w-[350px] md:w-[250px] w-full lg:h-[350px] md:h-[250px] h-[200px] p-4">
                {/* Background Shape */}
                <div className="absolute bottom-0 left-0 lg:w-[250px] w-[150px] lg:h-[250px] h-[150px] bg-[#236592] clip-bottom-left"></div>

                {/* Image Container */}
                <div className="relative overflow-hidden">
                  <img
                    src={BHK3}
                    alt="Styled Interior"
                    className="lg:w-[315px] md:w-[250px] w-full lg:h-[315px] h-[160px] object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="lg:my-[100px] mt-[50px] md:grid md:grid-cols-12 lg:pr-[225px]">
            <div className="relative col-span-6 text-start  md:px-[50px] py-[20px]">
              <div className=" clip-triangle bg-[#236592] w-[30px] h-[30px] absolute md:left-9 top-0"></div>
              <h3 className="text-[#7191E6] md:text-[24px] text-[16px] font-bold border-b-[1px] border-[#7191E6] md:mt-0 mt-3">
                3 BHK Villa
              </h3>
              <h1 className="lg:text-[30px] md:text-[24px] text-[22px] font-bold poppins">
                2460 Sq. Ft!
              </h1>
              <div className="grid grid-cols-12 gap-6 mt-3">
                <div className="col-span-4">
                  <img src={VILLA1} alt="villa" className="h-[50px] w-[50px]" />
                  <p className="font-normal text-[16px]">Bali-Themed Villas</p>
                </div>
                <div className="col-span-4">
                  <img src={VILLA2} alt="villa" className="h-[50px] w-[50px]" />
                  <p className="font-normal text-[16px]">Fully Furnished</p>
                </div>
              </div>
              <div className="grid grid-cols-12 gap-6 mt-3">
                <div className="col-span-4">
                  <img src={VILLA3} alt="villa" className="h-[50px] w-[50px]" />
                  <p className="font-normal text-[16px]">
                    Private Swimming Pool
                  </p>
                </div>
                <div className="col-span-4">
                  <img src={VILLA4} alt="villa" className="h-[50px] w-[50px]" />
                  <p className="font-normal text-[16px]">
                    Maintained By 5-Star Resort
                  </p>
                </div>
              </div>
              <button
                className="md:mt-2 text-[18px] text-white bg-[#7191E6] rounded-[6px] px-[20px] py-[12px] font-bold"
                onClick={() => scrollToSection(contactform)}
              >
                Get in Touch
              </button>
            </div>
            <div className="col-span-6">
              <div className="relative lg:w-[450px] md:w-[300px] lg:h-[500px] md:h-[350px] h-[240px] md:p-4 p-2">
                {/* Background Shape at Bottom Right */}
                <div className="absolute bottom-0 right-0 lg:w-[400px] md:w-[240px] w-[160px] lg:h-[400px] md:h-[240px] h-[160px] bg-[#236592] clip-bottom-right"></div>

                {/* Image Container */}
                <div className="relative overflow-hidden">
                  <img
                    src={BHK2}
                    alt="Styled Interior"
                    className="lg:w-[420px] md:w-[300px] w-full lg:h-[465px] md:h-[320px] h-[220px] object-cover"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="lg:mt-[100px] my-[50px] md:grid md:grid-cols-12 lg:pl-[225px] md:pl-[80px]">
            <div className="relative col-span-6 text-start md:px-[50px] py-[20px]">
              <div className=" clip-triangle bg-[#236592] w-[30px] h-[30px] absolute md:left-9 top-0 "></div>
              <h3 className="text-[#7191E6] md:text-[24px] text-[16px] font-bold border-b-[1px] border-[#7191E6] md:mt-0 mt-3">
                4 BHK Villa
              </h3>
              <h1 className="lg:text-[30px] md:text-[24px] text-[22px] font-bold poppins">
                3000 Sq. Ft
              </h1>
              <div className="grid grid-cols-12 gap-6 mt-3">
                <div className="col-span-4">
                  <img src={VILLA1} alt="villa" className="h-[50px] w-[50px]" />
                  <p className="font-normal text-[16px]">Bali-Themed Villas</p>
                </div>
                <div className="col-span-4">
                  <img src={VILLA2} alt="villa" className="h-[50px] w-[50px]" />
                  <p className="font-normal text-[16px]">Fully Furnished</p>
                </div>
              </div>
              <div className="grid grid-cols-12 gap-6 mt-3">
                <div className="col-span-4">
                  <img src={VILLA3} alt="villa" className="h-[50px] w-[50px]" />
                  <p className="font-normal text-[16px]">
                    Private Swimming Pool
                  </p>
                </div>
                <div className="col-span-4">
                  <img src={VILLA4} alt="villa" className="h-[50px] w-[50px]" />
                  <p className="font-normal text-[16px]">
                    Maintained By 5-Star Resort
                  </p>
                </div>
              </div>
              <button
                className="md:mt-2 text-[18px] text-white bg-[#7191E6] rounded-[6px] px-[20px] py-[12px] font-bold"
                onClick={() => scrollToSection(contactform)}
              >
                Get in Touch
              </button>
            </div>
            <div className="col-span-6">
              <div className="relative lg:w-[350px] md:w-[250px] w-full lg:h-[350px] md:h-[250px] h-[200px] p-4">
                {/* Background Shape */}
                <div className="absolute bottom-0 left-0 lg:w-[250px] w-[150px] lg:h-[250px] h-[150px] bg-[#236592] clip-bottom-left"></div>

                {/* Image Container */}
                <div className="relative overflow-hidden">
                  <img
                    src={BHK4}
                    alt="Styled Interior"
                    className="lg:w-[315px] md:w-[250px] w-full lg:h-[315px] h-[160px] object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="text-center">
            <h1
              className="text-[#3D52A1] lg:text-[48px] md:text-[36px] text-[28px] font-bold pb-[15px]"
              ref={floorPlanRef}
            >
              PROJECT FLOOR PLAN
            </h1>
            <p className="md:text-[18px] text-[16px] font-normal">
              Explore thoughtfully designed 1, 2, 3 & 4 BHK residences tailored
              for modern living. Each unit is optimized for spacious interiors,
              natural ventilation, and ample sunlight.
            </p>
            <div id="container" className="cols lg:mt-[100px] mt-[50px]">
              <div className="box floorplan1 lg:h-[500px] md:h-[350px] h-[250px]  rounded-[16px] flex flex-col justify-end  ">
                <div className="bg-[rgba(0,0,0,0.30)] shadow-[0px_0px_4px_0px_rgba(0,0,0,0.25)] md:px-[50px] px-[20px] rounded-bl-[16px] rounded-br-[16px] ">
                  <div className="flex justify-start ">
                    <h1 className="text-[#D9D9D9] md:text-[24px] text-[22px] font-bold text-end">
                      Master Plan
                    </h1>
                  </div>
                  <div className="flex justify-start ">
                    <button
                      className="bg-[#7191E6] mb-2  rounded-[6px] text-[18px] text-white font-bold px-[20px] py-[12px]"
                      onClick={() => scrollToSection(contactform)}
                    >
                      Know More
                    </button>
                  </div>
                </div>
              </div>

              <div className="box floorplan3 lg:h-[400px] md:h-[300px] h-[250px] rounded-[16px] flex flex-col justify-end ">
                <div className="bg-[rgba(0,0,0,0.30)] shadow-[0px_0px_4px_0px_rgba(0,0,0,0.25)] md:px-[50px] px-[20px] rounded-bl-[16px] rounded-br-[16px]">
                  <div className="flex justify-start ">
                    <h1 className="text-[#D9D9D9] md:text-[24px] text-[22px] font-bold text-end">
                      Master Plan
                    </h1>
                  </div>
                  <div className="flex justify-start ">
                    <button
                      className="bg-[#7191E6] mb-2  rounded-[6px] text-[18px] text-white font-bold px-[20px] py-[12px]"
                      onClick={() => scrollToSection(contactform)}
                    >
                      Know More
                    </button>
                  </div>
                </div>
              </div>
              <div className="box floorplan2 lg:h-[400px] md:h-[300px] h-[250px]  rounded-[16px] flex flex-col justify-end">
                <div className="bg-[rgba(0,0,0,0.30)] shadow-[0px_0px_4px_0px_rgba(0,0,0,0.25)] md:px-[50px] px-[20px] rounded-bl-[16px] rounded-br-[16px]">
                  <div className="flex justify-start ">
                    <h1 className="text-[#D9D9D9] md:text-[24px] text-[22px] font-bold text-end">
                      Master Plan
                    </h1>
                  </div>
                  <div className="flex justify-start ">
                    <button
                      className="bg-[#7191E6] mb-2  rounded-[6px] text-[18px] text-white font-bold px-[20px] py-[12px]"
                      onClick={() => scrollToSection(contactform)}
                    >
                      Know More
                    </button>
                  </div>
                </div>
              </div>
              <div className="box floorplan4 lg:h-[500px] md:h-[350px] h-[300px]  rounded-[16px] flex flex-col justify-end ">
                <div className="bg-[rgba(0,0,0,0.30)] shadow-[0px_0px_4px_0px_rgba(0,0,0,0.25)] md:px-[50px] px-[20px] rounded-bl-[16px] rounded-br-[16px]">
                  <div className="flex justify-start ">
                    <h1 className="text-[#D9D9D9] md:text-[24px] text-[22px] font-bold text-end">
                      Master Plan
                    </h1>
                  </div>
                  <div className="flex justify-start ">
                    <button
                      className="bg-[#7191E6] mb-2  rounded-[6px] text-[18px] text-white font-bold px-[20px] py-[12px]"
                      onClick={() => scrollToSection(contactform)}
                    >
                      Know More
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="lg:my-[100px] my-[50px]">
            <MasonryGrid />
          </div>
          {/* <div className='md:grid md:grid-cols-12 '>
                        <div className='col-span-6 md:pr-6 md:border-r-[5px] md:border-black'>
                            <img src={IMAGE} alt='img' className='lg:h-[400px] h-[300px] w-full' />
                        </div>
                        <div className='col-span-6 flex items-center justify-center h-full md:mt-0 mt-6'>
                            <h1 className='text-[#3D52A1] lg:text-[48px] md:text-[36px] text-[28px] font-bold poppins'>ABOUT PROJECT</h1>
                        </div>
                    </div> */}
          {/* <div className='md:grid md:grid-cols-12 gap-2'> */}

          <div>
            <div className="mt-2 text-start  lg:text-[14px] text-[12px]">
              <h1 className="font-bold text-[#3D52A1] lg:text-[48px] md:text-[36px] text-[28px] text-center">
                Why Choose Wellness Resort villas?
              </h1>
              <div className="text-center text-[20px] leading-[10px]">
                {" "}
                Resort-Style Living with Wellness at the Core{" "}
              </div>
              <div className=" w-[100%] mx-auto w-[60%] text-start mt-4">
                <div className="">
                  ✅ Bali-Themed Architecture & Interiors – A serene,
                  nature-inspired design that offers a resort-like lifestyle
                  every day.
                </div>
                <div>
                  ✅ Wellness-Focused Community – Yoga decks, Ayurveda spa,
                  meditation zones, and holistic wellness facilities for a
                  stress-free lifestyle.
                </div>
                <div>
                  ✅ Private Pool & Deck – Unlike standard villas, enjoy a
                  private retreat with world-class amenities.
                </div>
                <div>
                  ✅ One-of-a-kind Bali-Themed Resort Villas – Unlike generic
                  luxury villas, We offers a unique wellness-based lifestyle.
                </div>
                <div>
                  ✅ High Investment Potential – Better appreciation than
                  Mokhila, higher rental returns than Kollur & more exclusivity
                  than Tellapur.
                </div>
                <div>
                  ✅ Strategic Location in a Rapidly Growing Villa Corridor –
                  Close to IT hubs while still offering a serene, nature-filled
                  environment.
                </div>
                <div>
                  ✅ Designed for HNIs, NRIs, and Business Leaders – Unlike
                  regular villa communities, Mr.Housing India is crafted for
                  elite homeowners.
                </div>
                <div>
                  ✅ Hassle-Free Ownership – Fully furnished, private pools,
                  wellness-focused amenities – No other villa project offers
                  this.
                </div>
                <div>
                  📍 Book Your Site Visit Today & Experience the difference!
                </div>
              </div>
            </div>
            <div className="flex justify-center items-center">
              <button
                className="bg-[#7191E6] mb-2 rounded-[6px] text-[18px] text-white font-bold px-[20px] py-[10px] md:mt-2"
                onClick={() => scrollToSection(contactform)}
              >
                Get in Touch
              </button>
            </div>
          </div>
          {/* <div className='col-span-6 md:pr-6 md:mt-9 mt-2'>
                            <img src={IMAGE1} alt='img' className='lg:h-[420px] h-[400px] w-full' />
                        </div> */}
          {/* </div> */}
          <div
            className="lg:grid lg:grid-cols-12 lg:my-[100px] my-[50px]"
            ref={contactform}
          >
            <div className="col-span-6 text-start p-[20px]">
              <h1 className="text-[#3D52A1] lg:text-[48px] md:text-[36px] text-[28px] font-bold poppins">
                LOCATION
              </h1>
              <Accordion />
              {/* <div className="relative w-full h-96 rounded-[20px]">
                                <iframe className='rounded-[20px]' title='gif' src="https://www.google.com/maps/embed?pb=!1m12!1m8!1m3!1d1903.3132063934625!2d78.4273356!3d17.4297073!3m2!1i1024!2i768!4f13.1!2m1!1stechpixe%20hyderabad!5e0!3m2!1sen!2sin!4v1741472196031!5m2!1sen!2sin" width="100%" height="360" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                            </div> */}
              <div className="bg-location h-96 relative">
                {/* <button className='absolute top-[80%] left-[45%] translate-x-[-50%] translate-y-[-50%] rounded-[6px] text-[18px] font-bold px-[10px] py-[12px]' style={{border: '1px solid #8c7b56'}}>View On Google Maps</button> */}
                <a
                  href="https://www.google.com/maps/place/Ridhira+Zen/@17.5062998,77.7285119,13z"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="absolute top-[80%] left-[45%] translate-x-[-50%] translate-y-[-50%] rounded-[6px] text-[18px] font-bold px-[10px] py-[12px] text-black no-underline"
                  style={{ border: "1px solid #8c7b56" }}
                >
                  View On Google Maps
                </a>
              </div>
            </div>
            <div className="col-span-6 text-start p-[20px]">
              <h1 className="text-[#3D52A1] lg:text-[48px] md:text-[36px] text-[28px] font-bold poppins">
                CONTACT US
              </h1>
              <ContactUs />
              <div className="flex justify-center items-center gap-[35px] mt-6">
                <div>
                  <div className="flex justify-center">
                    <img
                      src={FACEBOOK}
                      alt="img"
                      className="md:w-[36px] w-[24px] md:h-[36px] h-[24px]"
                    />
                  </div>
                  <p className="md:text-[16px] text-[12px] font-normal">
                    FACEBOOK
                  </p>
                </div>
                <div>
                  <div className="flex justify-center">
                    <img
                      src={INSTA}
                      alt="img"
                      className="md:w-[36px] w-[24px] md:h-[36px] h-[24px]"
                    />
                  </div>
                  <p className="md:text-[16px] text-[12px] font-normal">
                    INSTAGRAM
                  </p>
                </div>
                <div>
                  <div className="flex justify-center">
                    <img
                      src={LINKEDIN}
                      alt="img"
                      className="md:w-[36px] w-[24px] md:h-[36px] h-[24px]]"
                    />
                  </div>
                  <p className="md:text-[16px] text-[12px] font-normal">
                    LINKEDIN
                  </p>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default HomeScreen;
